import cookies from "js-cookie";

export const saveUserToken = (token) => {
  try {
    cookies.set("hyro.token", token);
  } catch (e) {
    console.error("could not save token into cookie.");
  }
};
export const getUserToken = () => {
  try {
    return cookies.get("hyro.token");
  } catch (e) {
    console.error("could not load user token from cookie.");
  }
};
